import { useQuery } from '@tanstack/react-query';
import { getFeatureFlag } from '../api/featureFlags';

export const useFeatureFlag = (
  orgId: string | undefined,
  featureName: string,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: ['feature-flag', orgId, featureName],
    queryFn: () => getFeatureFlag(orgId!, featureName),
    enabled: (options?.enabled ?? true) && !!orgId,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
